module.exports = __webpack_public_path__ + "static/img/pcnavber.d64e8b60.png";